import "./App.css";
import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
  createTheme,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core/styles";
import MyAppBar from "./Components/MyAppBar.jsx";
import MyDrawer from "./Components/Drawer.jsx";
import UserState from "./context/UserState";

import { BrowserRouter as Router } from "react-router-dom";
import MainContainer from "./Components/MainContainer";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
overflowX:'hidden'
  },
  title: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
}));

function App() {
  const classes = useStyles();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: "#E94560",
          },
          secondary: {
            main: "#ffbc42",
          },
          type: prefersDarkMode ? "dark" : "light",
        },
      }),
    [prefersDarkMode]
  );
  return (
    <div className={classes.root}>
        <UserState>
        <Router>
          <ThemeProvider theme={theme}> 
              <MyAppBar />
             
             <MainContainer />
             
              <MyDrawer />
          </ThemeProvider>
        </Router>
      </UserState>
    </div>
  );
}

export default App;
